import cn from 'classnames';
import type React from 'react';
import { useForm } from 'react-hook-form';
import Modal from 'react-modal';
import { Close } from '@shared/assets';
import type { VideoType } from '@shared/types/common';
import { IconButton, TextInput } from '@shared/ui';
import * as st from './styles.module.scss';

const modalHeaderValuesMap = {
  Y: 'Youtube',
  R: 'Rutube',
  V: 'VK видео',
  O: 'Одноклассники',
  B: 'Boomstream',
} as const;
type Props = {
  isOpen: boolean;
  placeholder?: string;
  close: () => void;
  saveUrl: (url: string) => void;
  modalHeader?: string;
  videoType?: VideoType;
};

export const VideoUrlModal: React.FC<Props> = ({
  isOpen,
  placeholder = 'Вставьте ссылку (сервис)',
  modalHeader = 'Укажите ссылку на ресурс',
  videoType,
  close,
  saveUrl,
}) => {
  const { register, handleSubmit, watch } = useForm<{ url: string }>();
  const url = watch('url');

  const onSubmit = (data: { url: string }) => {
    saveUrl(data.url);
    close();
  };

  return (
    <Modal
      className={st.modal}
      overlayClassName={st.overlay}
      isOpen={isOpen}
      onRequestClose={close}
      ariaHideApp={false}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className={st.modal__head}>
          <IconButton variant="white" onClick={close}>
            <Close />
          </IconButton>
          <h3>{videoType ? modalHeaderValuesMap[videoType] : modalHeader}</h3>
          <button
            type="button"
            onClick={handleSubmit(onSubmit)}
            className={cn(st.submit, !url && st.disabled)}
          >
            Готово
          </button>
        </div>
        <div className={st.modal__link}>
          <TextInput fullWidth placeholder={placeholder} {...register('url')} />
          {/* <OutlinedInput {...register('url')} fullWidth placeholder={placeholder} /> */}
        </div>
      </form>
    </Modal>
  );
};
